<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
		    <div class="back_left" @click="$router.go(-1)"></div>
		    <div class="big_tit">{{$t('safe.language')}}</div>
		</div>
		<div class="wrap_box">
			<div class="item" v-for="(label,key) in lang_list" :key="key" @click="changeLang(key,$event)">
				<div class="left flex_center">
					<div class="lang_logo"><img :src="require(`../images/language/${key}.png`)"></div>
					<div class="info">{{ label }}</div>
				</div>
				<div v-if="lang == key">✓</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch'
	import bsHeader from '../../components/bsHeader.vue'
	import {lang_list,lang} from '@/locale/index'
	import {
		Toast
	} from 'vant'
	export default {
		name: "language",
		components: {
			bsHeader
		},
		data() {
			return {
				lang:this.$i18n.locale || lang,
				lang_list:lang_list
			};
		},
		created() {
			console.log(this.lang_list);
		},
		mounted() {
		},
		methods: {
			    changeLang(lang,event) {
					Toast.loading({
						// mask: true,
						duration: 200
					})
					this.lang = lang;
					this.$i18n.locale = lang;
					localStorage.setItem("lang", lang);
					this.$router.go(-1);
			    },
		}
	};
</script>

<style lang="less" scoped>
	.back_left {
		background: url(../../views/images/item/back_b.png) no-repeat center center;
	}
	.big_tit{
		color: #000000;
	}
	.wrap_box{
		display: flex;
		flex-direction: column;
		align-items: center;
		.item{
			height: 50px;
			width: 95%;
			padding: 16px 10px 16px 0px;
			border-bottom: 1px solid #ECECEC;
			font-size: 14px;
			color: rgba(0,0,0,.8);
			font-weight: bold;
			line-height: 20px;
			display: flex;
			justify-content: space-between;
			.right{
				width: 20px;
				height: 20px;
				background: url(../images/user/arrow.png) no-repeat center center;
				background-size: 100% 100%;
			}
			.right_info{
				color: rgba(0,0,0,.6);
			}
			.tips{
				color: rgba(0,0,0,.6);
				margin-left: auto;
				margin-right: 4px;
				font-weight: normal;
			}
			.left{
				.lang_logo {
					 width: 33px;
					 height: 33px;
					 border-radius: 50%;
					 display: flex;
					 align-items: center;
					 justify-content: center;
					 overflow: hidden;
					 border: 1px solid #eee;
					 margin-right: 10px;
					 img {
						 display: block;
						 width: 112%;
						 height: 112%;
					 }
				}
			}
		}
	}
</style>
